export default __webpack_public_path__ + "static/media/logo_white_words_transparent_bg.87677c3d.png";